import { render } from "./CollapsibleTags.vue?vue&type=template&id=2406297b&scoped=true"
import script from "./CollapsibleTags.vue?vue&type=script&lang=js"
export * from "./CollapsibleTags.vue?vue&type=script&lang=js"

import "./CollapsibleTags.vue?vue&type=style&index=0&id=2406297b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2406297b"]])

export default __exports__